import { useStyletron } from 'baseui';

export function IconHumidifier({ height, width, color }: any) {
    return (
        <svg width={width || '100%'} height={height || '100%'} x="0px" y="0px"  viewBox="8 0 64 64" enableBackground="new 0 0 64 64;" >
            <g>
            <path fill={color} d="M40,0 A50,50 0 0 1 60,50 A20,20 0 0 1 20,40 A15,17 0 0 1 25,31 A50,45 0 0 0 40,0"></path>
            </g>
        </svg>
    );
}
